import { ref } from 'vue'

/**
 * Close the modal only if the mousedown and mouseup both happen on the backdrop
 * not if the user mouses down on the backdrop and then releases inside the modal, or vice-versa
 *
 * Track whether mousedown happened on the backdrop (mouseDownOnBackdrop).
 * On mouseup, only close if:
 * The mousedown started on the backdrop and
 * The mouseup also ended on the backdrop.
 */

export function useBackdropClick(onClose: () => void): {
  handleMouseDown: (e: MouseEvent) => void
  handleMouseUp: (e: MouseEvent) => void
} {
  const mouseDownOnBackdrop = ref(false)

  function handleMouseDown(): void {
    mouseDownOnBackdrop.value = true
  }

  function handleMouseUp(): void {
    if (mouseDownOnBackdrop.value) {
      onClose()
    }
    mouseDownOnBackdrop.value = false
  }

  return {
    handleMouseDown,
    handleMouseUp,
  }
}
